function getComp(name) {
  return import(
    `./${name}.vue`
  );
}

export const route = {
  path: '/waitApprovalList',
  name: 'waitApprovalList',
  component: getComp.bind(null, 'WaitApprovalList'),
  meta: {
    matchNav: 'waitApprovalList',
  },
};